export default __webpack_public_path__ + "static/media/Achiton of Illuminant Conviction.ab052783.jpg";